<template>
  <Poptip
    class="search-poptip"
    trigger="focus"
    placement="bottom"
    padding="24px"
    @on-popper-hide="handleHidePopper"
    :disabled="disabledPoptip"
  >
    <Input
      class="search-input"
      ref="search-input"
      :prefix="prefix"
      :suffix="suffix"
      :value="value"
      placeholder="点击搜索视频"
      size="large"
      @on-change="handleChangeSearch"
      @on-enter="handleSearch"
      @on-clear="handleClearSearch"
      clearable
    />
    <div class="search-board" slot="content">
      <div class="history-list">
        <div class="list-header">
          <div class="list-label">最近搜索</div>
          <div class="clean-btn">
            <Button
              v-show="searchHistory && searchHistory.length"
              type="text"
              @click="handleClearHistory"
            >
              <trash-2-icon size="16" class="icon-trash"></trash-2-icon>
              <span>清空记录</span>
            </Button>
          </div>
        </div>
        <div class="tag-list">
          <template v-for="(item, index) in searchHistory">
            <span
              :key="index"
              class="history-tag"
              @click="handleTagTap(item)"
              >{{ item }}</span
            >
          </template>
        </div>
      </div>
    </div>
  </Poptip>
</template>

<script>
import { Trash2Icon } from 'vue-feather-icons'
import { localStorage } from '../../utils/storage'
import { SEARCH_HISTORY } from '../../utils/enum'

export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    openHistory: {
      type: Boolean,
      default: true
    },
    prefix: {
      type: String
    },
    suffix: {
      type: String
    }
  },
  computed: {
    // 是否禁用 搜索历史
    disabledPoptip() {
      // 如果是不打开历史记录直接禁止
      if (!this.openHistory) return true

      return !this.searchHistory || !this.searchHistory.length
    }
  },
  data() {
    return {
      searchVisible: false,
      searchHistory: []
    }
  },
  methods: {
    /**
     * @description: 输入框内容改变
     * @param {object} event
     * @return {void}
     */

    handleChangeSearch(event) {
      const { value } = event.target
      this.$emit('change', value)
    },
    /**
     * @description: 点击清除
     * @return {void}
     */
    handleClearSearch() {
      this.$emit('change', '')
    },
    /**
     * @description: 搜索
     * @param {object} e
     * @return {void}
     */
    handleSearch(e) {
      const { value } = e.target
      if (this.openHistory) {
        // 记录搜索历史
        if (this.searchHistory.includes(value)) {
          const index = this.searchHistory.findIndex(item => item === value)

          if (index >= 0) {
            this.searchHistory.splice(index, 1)
          }
        }
        this.searchHistory.unshift(value)
        localStorage.setItem(SEARCH_HISTORY, JSON.stringify(this.searchHistory))
      }

      this.$emit('search', value)

      this.$refs['search-input'].blur()
    },
    /**
     * @description: 点击tag
     * @param {string} tagValue
     * @return {void}
     */
    handleTagTap(tagValue) {
      this.$emit('change', tagValue)

      this.$emit('search', tagValue)
      this.$refs['search-input'].blur()
    },
    /**
     * @description: 清空搜索历史
     * @return {void}
     */
    handleClearHistory() {
      this.searchHistory = []
      localStorage.setItem(SEARCH_HISTORY, JSON.stringify(this.searchHistory))
    },
    /**
     * @description: 提示框显示时触发
     * @return {void}
     */
    handleHidePopper() {
      // 同步本地搜索历史
      const isExist = localStorage.isExistItem(SEARCH_HISTORY)
      let historyTags = isExist
        ? JSON.parse(localStorage.getItem(SEARCH_HISTORY).data)
        : ''
      if (!Array.isArray(historyTags)) {
        historyTags = []
      }
      this.searchHistory = historyTags
    }
  },
  mounted() {
    if (!this.openHistory) return
    this.handleHidePopper()
  },
  components: {
    Trash2Icon
  }
}
</script>

<style lang="less">
.search-poptip {
  position: relative;
  width: 100%;

  .ivu-input {
    border: none;
    border-radius: 8px;
    background: #f5f5f7;
  }

  .ivu-poptip-rel {
    position: relative;
    width: 100%;
  }

  .ivu-poptip-popper {
    padding: 0;
    padding-top: 4px;
    width: 100%;
    min-width: 320px;

    .ivu-poptip-arrow {
      display: none;
    }

    .ivu-poptip-inner {
      border-radius: 8px;
      border: 1px solid rgba(0, 0, 0, 0.06);
      box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.06);
    }
  }

  .list-label {
    // margin-bottom: 8px;
    color: #ababab;
    line-height: 20px;
  }

  .history-list {
    position: relative;

    .list-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .clean-btn {
      // margin-bottom: 8px;
      outline: none;

      .ivu-btn-text {
        display: flex;
        align-items: center;
        padding: 0;
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        color: #a6aab0;

        > span {
          display: flex;
          align-items: center;
        }

        &:focus {
          box-shadow: none;
        }
      }

      .icon-trash {
        margin-right: 4px;
      }
    }

    .tag-list {
      display: flex;
      flex-wrap: wrap;

      .history-tag {
        margin: 0;
        margin-top: 12px;
        margin-right: 32px;
        color: #3b3b3b;
        font-weight: bold;
        font-size: 16px;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?cacefe0c